import { Form } from "formik";
import React, { Component } from "react";

import {
  BASIC_SCHEMA,
  PATIENT_BASIC_SCHEMA,
  PREFERRED_NAME_SCHEMA_NON_PATIENT,
} from "@/features/patient/schema/PatientProfileInfoSchema";
import { Button2 } from "@/ui2/atoms/Button";
import { CustomForm } from "@/component-library/CustomForm";
import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import FormikInput from "@/components/UI/FormikInput";
import FormikMobileInput from "@/components/UI/formikMobileInput";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import Hr from "@/components/UI/Hr";
import { isAdult } from "@/utils/profileUtilsTyped";
import { isUserAdmin, isUserPatient } from "@/utils/authToken";
import {
  PATIENT_VALIDATION_SCHEMA,
  VALIDATION_SCHEMA,
} from "@/features/patient/schema/PatientProfileValidation";
import { renderTitleWithValue } from "@/components/Patient/Profile/renderTitleWithValue";
import { SubmitControls } from "@/components/Common/SubmitControls";
import { testLocator } from "@/lib/helpers/test-locator";

import { IdentityDocument } from "./IdentityDocument";

class BasicInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: props.edit,
      editableData: null,
      profileData: props.data,
    };
  }

  componentDidMount() {
    let profileData = this.state.profileData;

    if (isUserAdmin()) {
      profileData = this.transformDOBsToValidStrings(profileData);
    }

    this.setState({
      editableData: profileData,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      let profileData = this.state.profileData;

      if (isUserAdmin()) {
        profileData = this.transformDOBsToValidStrings(profileData);
      }

      this.setState({
        editableData: profileData,
      });
    }
  }

  toggleEditBasicInfo = () => {
    this.setState((ps) => {
      return {
        edit: !ps.edit,
      };
    });
  };

  renderBasicForm = (formikProps) => {
    let schema = PATIENT_BASIC_SCHEMA;

    const isPatientAdult = isAdult(this.state.profileData?.dob);

    if (!isUserPatient()) {
      schema = BASIC_SCHEMA;
    }

    return (
      <Form>
        <div className="mx-auto px-0">
          <div className="container px-0">
            <div className="row">
              {schema.map((formEl) => {
                const testId = `PatientProfileBasicInfo_${formEl.name}`;

                if (formEl.elementType === "segment") {
                  return (
                    <h6 className="col-12" key={formEl.displayName}>
                      <b>{formEl.displayName}</b>
                    </h6>
                  );
                } else if (formEl.elementType === "readOnly") {
                  return (
                    <div className="col-12 col-lg-6" key={formEl.name}>
                      <FormikInput
                        disabled
                        errors={formikProps.errors}
                        formEl={formEl}
                        inputBorderDisabled="border-0 px-0"
                        touched={formikProps.touched}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div className="col-12 col-lg-6" key={formEl.name}>
                      {formEl.name === "email" && this.state.edit ? (
                        <FormikInput
                          disabled
                          errors={formikProps.errors}
                          formEl={formEl}
                          inputBorderDisabled="border-0 px-0"
                          touched={formikProps.touched}
                        />
                      ) : formEl.name == "mobile" ? (
                        <FormikMobileInput
                          errors={formikProps.errors}
                          formEl={formEl}
                          onChange={async (val) => {
                            await formikProps.setFieldValue("mobile", val.value);
                            formikProps.setFieldTouched("mobile");
                          }}
                          testId={testId}
                          touched={formikProps.touched}
                          value={formikProps && formikProps.values.mobile}
                        />
                      ) : formEl.name == "dob" ? (
                        <FormikMobileInput
                          errors={formikProps.errors}
                          formEl={formEl}
                          onChange={async (val) => {
                            await formikProps.setFieldValue("dob", val.value);
                            formikProps.setFieldTouched("dob");
                          }}
                          testId={testId}
                          touched={formikProps.touched}
                          value={formikProps && formikProps.values.dob}
                        />
                      ) : (
                        <FormikInput
                          errors={formikProps.errors}
                          formEl={formEl}
                          testId={testId}
                          touched={formikProps.touched}
                        />
                      )}
                    </div>
                  );
                }
              })}
            </div>

            <div className="row">
              <div className="col-12 col-lg-6">
                {isPatientAdult && (
                  <IdentityDocument
                    isDisabled
                    personalIdFront={this.state.profileData.personal_id_front}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mb-3 d-lg-none">
          <Hr />
        </div>

        <SubmitControls cancelHandler={this.toggleEditBasicInfo} />
      </Form>
    );
  };

  alteredFormData = (data) => {
    const alteredData = { ...data };

    let DOBnumber = {
      dob: alteredData.dob,
      // primaryDOB: alteredData.primary_insurance.policy_dob,
      // secondaryDOB: alteredData.secondary_insurance.policy_dob,
    };

    DOBnumber = {
      dob: `${DOBnumber.dob.substring(0, 2)}/${DOBnumber.dob.substring(
        2,
        4,
      )}/${DOBnumber.dob.substring(4, 8)}`,
      // primaryDOB: `${DOBnumber.primaryDOB.substring(0, 2)}/${DOBnumber.primaryDOB.substring(2, 4)}/${DOBnumber.primaryDOB.substring(4, 8)}`,
      // secondaryDOB: `${DOBnumber.secondaryDOB.substring(0, 2)}/${DOBnumber.secondaryDOB.substring(2, 4)}/${DOBnumber.secondaryDOB.substring(4, 8)}`,
    };

    return DOBnumber;
  };

  transformDOBsToValidStrings = (data) => {
    const updatedData = { ...data };

    if (Object.hasOwn(updatedData, "dob")) {
      updatedData["dob"] = updatedData["dob"].replace(/\//g, "");
    }

    return updatedData;
  };

  submitHandler = (formData, action) => {
    const newFormData = { ...formData };

    if (isUserAdmin()) {
      const newDOBData = this.alteredFormData(formData);

      newFormData.dob = newDOBData.dob;
    }
    // newFormData.primary_insurance.policy_dob = newDOBData.primaryDOB;
    // newFormData.secondary_insurance.policy_dob = newDOBData.secondaryDOB;

    const data = { ...newFormData };

    this.setState((ps) => {
      return {
        edit: !ps.edit,
        // editableProfileData: this.getEditableData(data),
        editableProfileData: null,
        profileData: { ...data },
      };
    });

    let schema = PATIENT_BASIC_SCHEMA;

    if (!isUserPatient()) {
      schema = BASIC_SCHEMA;
    }

    this.props.submit(data, action, schema);
  };

  render = () => {
    let validationSchema = VALIDATION_SCHEMA;

    if (!isUserAdmin()) {
      validationSchema = PATIENT_VALIDATION_SCHEMA;
    }

    const isPatientAdult = isAdult(this.state.profileData?.dob);

    return (
      <DashboardCard2
        Actions={
          !this.props.isReadOnly && (
            <Button2 isDisabled={this.state.edit} onPress={this.toggleEditBasicInfo} variant="link">
              Edit
            </Button2>
          )
        }
        title="Basic Information"
        {...getAutomationDataAttr("patient-profile-basic-info")}
        {...testLocator("patient-profile-basic-info")}
      >
        <div className={!this.state.edit && "tw:grid tw:grid-cols-2 tw:gap-6"}>
          {!this.state.edit && (
            <>
              {iterableBasicInfo(this.state.profileData).map((item) => {
                let value = item.value;

                if (item.title === "Email") {
                  const valueSuffix = ` (${
                    this.state.profileData.email_verified ? "verified" : "not verified"
                  })`;

                  value = `${value}${valueSuffix}`;
                }

                return (
                  <div key={item.title}>
                    {renderTitleWithValue(item.title, value, item.subtitle, item.optional)}
                  </div>
                );
              })}

              {isPatientAdult && (
                <IdentityDocument
                  entityId={this.state.profileData.username}
                  personalIdFront={this.state.profileData.personal_id_front}
                />
              )}
            </>
          )}

          <div
            {...getAutomationDataAttr("patient-profile-basic-info-form")}
            {...testLocator("patient-profile-basic-info-form")}
          >
            {this.state.edit && (
              <CustomForm
                initialValues={this.state.editableData}
                onSubmit={this.submitHandler}
                render={this.renderBasicForm}
                validationSchema={validationSchema}
              />
            )}
          </div>
        </div>
      </DashboardCard2>
    );
  };
}

export default BasicInfo;

const iterableBasicInfo = (profileData) => [
  { title: "Legal First Name", value: profileData.first_name || "" },
  { title: "Legal Last Name", value: profileData.last_name || "" },
  {
    optional: true,
    title: PREFERRED_NAME_SCHEMA_NON_PATIENT.elementConfig.label,
    value: profileData.preferred_name || "",
  },
  { optional: true, title: "Preferred Pronouns", value: profileData.preferred_pronouns || "" },
  { title: "Date of Birth", value: profileData.dob || "" },
  { title: "Gender", value: profileData.gender || "" },
  { title: "Mobile", value: profileData.mobile || "" },
  { title: "Email", value: profileData.email || "" },
  { title: "Street", value: profileData.address.street || "" },
  { title: "State", value: profileData.address.state || "" },
  { title: "City", value: profileData.address.city || "" },
  { title: "Zip", value: profileData.address.zip_code || "" },
];
